import Homecontent from "./data/homecontent";
import { Topheader } from "./common/topheader";
import astro from "./images/services/career.jpg";
import { Innerbanner } from "./common/innerbanner";
import {Footer} from './common/footer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneSquare } from "@fortawesome/free-solid-svg-icons";
function  Career(props2){


    return(
<div>
<Topheader></Topheader>
<Innerbanner title={"Job and Career Astrolgy Guidance "}></Innerbanner>

<div className="container-fluid">

    <div className="container">
<div className="d-flex flex-column flex-sm-row flex-lg-row flex-md-row">

    <div className="bg-light shadow p-3 m-3 flex-fill"><img  src={astro } alt="famous astrologer Gurgaon" className="img-fluid float-start m-3"></img>
   <p> 
   Astrological insights can be a valuable tool in navigating your career path. Here's how astrologers like Sanjay Bhargav can assist with job and career guidance</p>
    
<p>
<span className="fw-bolder">Career Path Analysis </span> By examining the 10th house (house of career) in your horoscope along with the ruling planets, astrologers can suggest suitable career paths that align with your skills, interests, and inherent strengths.</p><p>
<span className="fw-bolder">Timing of Career Moves:</span> Astrology helps identify auspicious times for career changes, promotions, or starting a new business. Understanding planetary transits and their impact on your professional life can lead to more informed decisions.</p>
<p>
<span className="fw-bolder">Business Ventures:</span>  For those considering entrepreneurship, astrologers offer insights into the most favorable times to launch a business, including potential partnerships and investment opportunities.</p><p>
<span className="fw-bolder">Workplace Relationships</span>  Relationship dynamics at work are crucial for career growth. Astrology can provide guidance on how to handle workplace conflicts, build strong professional networks, and collaborate effectively with colleagues.
</p>
<p>
<span className="fw-bolder">Wealth Accumulation</span>  Relationship dynamics at work are crucial for career growth. Astrology can provide guidance on how to handle workplace conflicts, build strong professional networks, and collaborate effectively with colleagues.By analyzing the 2nd (wealth) and 11th (gains) houses, astrologers can offer advice on managing finances, investment strategies, and potential sources of income
</p>

<p>
<span className="fw-bolder">Remedies for Career Obstacles</span>  If you're facing career challenges, astrologers can recommend specific remedies such as gemstones, mantras, or rituals to help mitigate negative influences and enhance positive planetary effects.</p>
<p>Astrology aims to provide personalized career guidance based on your astrological chart, helping you make more informed, confident decisions.</p>
<p className="text-center"><h6>Interested in exploring how astrology can shape your career?</h6><a href='https://api.whatsapp.com/send?phone=919873336259&text='><button className="btn btn-danger">Let me know if there are specific questions or areas you're curious about!</button></a></p>
    </div>


</div>


    </div>



</div>
<Footer></Footer>









</div>






 );







    
}
export {Career} ;